// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDelinquentClaimsMultiEmployersSummaryRecordDto } from './IDelinquentClaimsMultiEmployersSummaryRecordDto';
import {
    IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON,
    IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IDelinquentClaimsMultiEmployersSummaryRecordDto';
import type { IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IDelinquentClaimsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<IDelinquentClaimsMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoDelinquentClaimsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON)),
    };
}

